<template>
  <span
    class="aj-star"
    v-on="$listeners"
  >
    <aj-icon
      :class="classObject"
      shape="star"
      class="aj-star__icon"
    />
  </span>
</template>

<script>
import AjIcon from '../AjIcon/AjIcon.vue';

export default {
  name: 'AjStar',

  components: {
    AjIcon,
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },

    big: {
      type: Boolean,
      default: false,
    },

    large: {
      type: Boolean,
      default: false,
    },

    clickable: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObject () {
      return {
        'aj-star__icon--small': this.small,
        'aj-star__icon--big': this.big,
        'aj-star__icon--large': this.large,
        'aj-star__icon--clickable': this.clickable,
        'aj-star__icon--selected': this.selected,
        'aj-star__icon--active': this.active,
      };
    },
  },
};
</script>

<style lang="scss" scoped src="./AjStar.scss" />
